<script>
    export let corner = ''
</script>

<div 
class="wrapper {$$props.class || ''}" 
    class:left-top={corner === 'left-top'}
    class:left-bottom={corner === 'left-bottom'}
    class:right-top={corner === 'right-top'}
    class:right-bottom={corner === 'right-bottom'}
    style={$$props.style || ''}
>
    <slot />
</div>

<style lang="scss" module>
    .wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 386px;
        height: 413px;
        border-radius: 75px;
        background: #FFFFFF;
        box-shadow: 6px 4px 74px rgba(201, 100, 19, 0.14);

        &.left-top {
            border-radius: 0 75px 75px 75px;
        }

        &.right-top {
            border-radius: 75px 0 75px 75px;
        }

        &.right-bottom {
            border-radius: 75px 75px 0 75px;
        }

        &.left-bottom {
            border-radius: 75px 75px 75px 0;
        }
    }
</style>